
import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import {ProductDetail} from "@/model/FinancialBookingModels";
import {exportJson2Excel} from "@/utils/excel";
import {formatJson} from "@/utils";

@Component({name: "ProductDetailDialog"})
export default class extends Vue {
  @Prop({ required: false, default: false }) private show: boolean;
  @Prop({ required: true }) private data: ProductDetail;
  private data_: ProductDetail = new ProductDetail();

  @Watch("data", { deep: true, immediate: true })
  private watchData() {
    this.data_ = this.data;
  }

  private close() {
    this.$emit("update:show", false);
  }

  private exportExcel() {
    const headers = [
      "报关品名",
      "客户号码",
      "华强号码",
      "OE号码",
      "REF NO.",
      "QTY",
      "采购订单号",
      "订单批次",
      "公司折后定价",
      "IV其他费用分配后定价",
      "供应商"
    ];
    const fieldNames = [
      "declarationDescription",
      "guestModel",
      "hqOrJrNumber",
      "oeNumber",
      "refNumber",
      "totalNumberPcs",
      "purchaseOrderNumber",
      "batch",
      "companyDiscountPrice",
      "otherAmountDistributePrice",
      "factoryName"
    ];
    exportJson2Excel(
        headers,
        formatJson(fieldNames, this.data_),
        `报关产品详情-${new Date()}`
    );
  }
}

